var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator-filter flex items-baseline"},[_c('el-badge',{staticClass:"item font-app text-sm font-normal"},[_c('i',{staticClass:"el-icon-set-up"}),_c('span',{staticClass:"pl-1",class:{'font-bold': _vm.counter > 0}},[_vm._v(_vm._s(_vm.counter + ' '+ _vm.pluralize(_vm.counter,'filter','filters') + ' applied'))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }